import React from "react";
import { Box, CircularProgress, Modal, Typography } from "@mui/material";
import { PRIMARY_ORANGE } from "./constants";

const LoadingModal = ({ open = true, message = "Loading..." }) => (
  <Modal
    open={open}
    aria-labelledby="loading-modal-title"
    aria-describedby="loading-modal-description"
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    disableEscapeKeyDown
    closeAfterTransition
  >
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "12px",
        px: 4,
        py: 3.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        minWidth: 220,
        outline: "none",
        boxShadow: "0 12px 40px rgba(0, 0, 0, 0.12)",
      }}
    >
      <CircularProgress size={42} thickness={4} sx={{ color: PRIMARY_ORANGE }} />
      <Typography
        id="loading-modal-description"
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 500 }}
      >
        {message}
      </Typography>
    </Box>
  </Modal>
);

export default LoadingModal;
